<section class="row">
	<ng-content></ng-content>
	<section class="col-21">
		<div class="chart-wrapper">
			<div class="chart-title-section">
				<h3 class="text-16-bold text-uppercase" data-cy="ate-empty-column-chart-title">{{ sectionTitle }}</h3>
			</div>
			<div class="inner-chart-wrapper">
				<div id="left-content-wrapper" class="left-content-wrapper">
					<div [class.invisible]="!showSubHeaderContent" class="chart-focus-value">
						<span class="text-36-bold" data-cy="ate-empty-column-chart-sub-header-value">{{ subHeaderValue }}</span>
						<p class="text-14 text-uppercase" data-cy="ate-empty-column-chart-sub-header-text">{{ subHeaderText }}</p>
					</div>
					<div class="chart-legend" data-cy="ate-empty-column-chart-legends">
						<ng-container *ngFor="let category of categories">
							<div class="legend-item" *ngIf="isDisplaying(category)">
								<div class="square" [ngStyle]="{ 'background-color': category.attribute.colorTheme }"></div>
								<span class="text-14 color-secondary">{{ category.formattedValue }}</span>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="chart-container">
					<bfa-chart
						[height]="height"
						type="emptyColumnChart"
						[data]="data"
						[data-index]="selectedPortfolioIndex"
						[customAttributes]="emptyColumnChartAttributes"
					></bfa-chart>
				</div>
			</div>
		</div>
	</section>
</section>
